module.exports = __webpack_public_path__ + "static/media/galdisa_acerca_de_cert_veritas.523476c6.png";